<template>
  <div class="update-add-videos-adaptive-game container-fluid">
    <div class="">
      <div class="row padding-4px">
        <div class="col-md-12 col-lg-12">
          <div class="font-size-19px create-lesson-input-text-style">
            Videos<span class="glyphicon glyphicon-plus-sign margin-left-10px font-size-17px cursor-pointer" @click="openCreateVideoOverlay"></span>
          </div>  
        </div>
      </div>
      <create-video v-if="showCreateVideoOverlay" :lessonObj="getParentLessonObj" :adaptiveGameResp="getAdaptiveGameResp" @openOverlay="updateCloseVideoOverlayValue"></create-video>
      <div class="row">
        <div class="col-md-12 col-lg-12 padding-right-0px">
          <video-adaptive-game-list :videoList="getVideoList" :lessonObj="getParentLessonObj" :adaptiveGameResp="getAdaptiveGameResp" @updateVideoList="updatedVideoList"></video-adaptive-game-list>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AlertBox from '@/components/AlertOverlay'
import VideoAdaptiveGameList from '@/components/adaptive_game/Update-element/UpdateVideoAdaptiveGameList'
// import CreateVideo from '@/components/adaptive_game/AdaptiveGameCreateVideoElement'
import CreateVideo from '@/components/adaptive_game/Update-element/UpdateAdaptiveGameCreateDescriptiveVideoElement'
export default {
  props: ['lessonObj', 'adaptiveGameResp', 'serverVideoList'],
  created: function () {
    this.setVideoList()
  },
  data: function () {
    return {
      showAlertDialog: false,
      errorMsg: '',
      showSpinner: false,
      showCreateVideoOverlay: false,
      videoList: []
    }
  },
  name: 'update-add-videos-adaptive-game',
  methods: {
    setVideoList: function () {
      this.videoList = this.getServerVideoList
    },
    updatedVideoList (value) {
      this.videoList = value
      // console.log('New updated List after edit or delete >>> ' + JSON.stringify(this.videoList))
    },
    openCreateVideoOverlay: function (event) {
      this.showCreateVideoOverlay = true
    },
    updateCloseVideoOverlayValue (value) {
      this.showCreateVideoOverlay = !value.closeOverlay
      if (value.currentResponseObj !== null && value.currentResponseObj.currentResponseObj !== 'null' && value.currentResponseObj.currentResponseObj !== '') {
        this.videoList.push(value.currentResponseObj)
      }
    }
  },
  components: {
    'alert-box': AlertBox,
    'video-adaptive-game-list': VideoAdaptiveGameList,
    'create-video': CreateVideo
  },
  computed: {
    getServerVideoList: {
      get: function () {
        return this.serverVideoList
      }
    },
    getParentLessonObj: {
      get: function () {
        return this.lessonObj
      }
    },
    getAdaptiveGameResp: {
      get: function () {
        return this.adaptiveGameResp
      }
    },
    getVideoList: {
      get: function () {
        return this.videoList
      }
    }
  },
  watch: {
    videoList: function (newValue, oldValue) {
      var objToPass = {
        list: this.videoList,
        type: 'Video'
      }
      this.$emit('videoList', objToPass)
    }
  }
}
</script> 
<style scoped>
.animationload {
    height: 100%;
    left: 0;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 10000;
}
.osahanloading {
    animation: 1.5s linear 0s normal none infinite running osahanloading;
    background: #fed37f none repeat scroll 0 0;
    border-radius: 50px;
    height: 50px;
    left: 50%;
    margin-left: -25px;
    margin-top: -25px;
    position: absolute;
    top: 50%;
    width: 50px;
}
.osahanloading::after {
    animation: 1.5s linear 0s normal none infinite running osahanloading_after;
    border-color: #85d6de transparent;
    border-radius: 80px;
    border-style: solid;
    border-width: 10px;
    content: "";
    height: 80px;
    left: -15px;
    position: absolute;
    top: -15px;
    width: 80px;
}
@keyframes osahanloading {
0% {
    transform: rotate(0deg);
}
50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
}
100% {
    transform: rotate(360deg);
}
}
.red{
  background-color: red;
}
.MainDiv
{
  overflow-y: hidden !important;
}
.margin-Top-0Perc{
  margin-top: 0%;
}
.margin-Top-1Perc{
  margin-top: 1%;
}
.margin-Top-2Perc
{
	margin-top: 2%;
}
.margin-Top-3Perc
{
	margin-top: 3%;
}
.margin-Top-8Perc
{
	margin-top: 8%;
}
.margin-bottom-0Perc
{
	margin-bottom: 0%;
}
.margin-bottom-5Perc
{
	margin-bottom: 5%;
}
.margin-bottom-2Perc
{
	margin-bottom: 2%;
}
.margin-top-2Perc
{
	margin-top: 2%;
}
.margin-left-0Perc
{
    margin-left:0%;
}
.margin-left-1Perc
{
    margin-left:2%;
}
.margin-left-2Perc
{
    margin-left:2%;
}
.margin-left-3Perc{
  margin-left:3%;
}
.margin-left-4Perc
{
    margin-left:4%;
}
.margin-left-5Perc{
  margin-left:5%;
}
.margin-left-6Perc{
  margin-left:6%
}
.margin-left-9Perc
{
    margin-left:9%;
}
.padding-Left-0px
{
  padding-left: 0px !important;
}
.padding-Left-30px
{
  padding-left: 3% !important;
}
.text-align-center
{
  text-align: center;
}
.left-border
{
  border-left: 1px solid #aaa;
}

.background-color-red
{
	background-color: red;
}
.cf-border
{
	border:1px solid black;
}
.text-align-left
{
  text-align: left;
}
.font-size-1-3vw
{
  font-size: 1.3vw;
}
.font-size-20px
{
  font-size: 20px;
}
.background-gray{
  background-color: #ddd;

}

.border-rounded{
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}

  .overflow-x-hidden{
    overflow-x: hidden !important;
  }
  .font-size-18px {
  font-size: 18px;
}
.gray-border {
  border: 1px solid #aaa;
}
.white-BG {
  background-color: #ffffff;
}
.width-70Perc {
  width: 70%;
}
.width-90Perc {
  width: 90%;
}
.margin-auto{
margin: auto;
}
.margin-bottom-0px {
  margin-bottom: 0px !important;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.75);
  overflow-x: hidden;
  /*transition: 0.5s;*/
}
.overlay-overall-width-0Perc {
  width: 0%;
}
.overlay-overall-width-100Perc {
  width: 100% !important;
}
.overlay-content {
  position: relative;
  top: 25%;
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.center-aligned-div {
  margin: 0 auto;
}
.white-porition-overlay-width-80Perc {
  width: 80%;
}
.background-color-white {
  background-color: #ffffff !important;
}
.close-text-font-style {
  color: #aaa;
  font-size: 30px;
}
.margin-right-1Perc {
  margin-right: 1%;
}
.margin-top-2Perc {
  margin-top: 2%;
}
.cursor-pointer {
  cursor: pointer;
}
.close-img-width-height {
  width: 2%;
  height: 2%;
}
.float-right {
  float: right;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.border-rounded {
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}
.create-lesson-input-text-style {
  color: #34495e;
  font-size: 17px;
}
.padding-right-0px {
  padding-right: 0px !important;
}
switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
.text-align-right {
  text-align: right;
}
.create-lesson-overlay-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.black-font-color
{
  color: #000 !important;
}
.border-red {
    border:1px solid red;
}
.margin-bottom-2Perc {
    margin-bottom: 2%;
}
.font-size-19px {
    font-size: 19px;
}
.padding-right-6px {
    padding-right:6px; 
}
.padding-top-1Perc {
    padding-top:1%;
}
.padding-left-0px {
    padding-left:0px;
}
.margin-left-10px {
    margin-left: 10px;
}
.padding-4px {
  padding:4px;
}
.font-size-17px {
  font-size:17px;
}
</style>


// WEBPACK FOOTER //
// src/components/adaptive_game/Update-element/UpdateAddVideosAdaptiveGame.vue